<template>
  <div class="md:my-8 lg:my-8 my-6">
    <form>
      <div class="row">
        <div class="form-group md:col-6 lg:col-6 col-12">
          <label for="customFileLang" class="form-control-label"
            >Cover Photo</label
          >
          <div class="custom-file cursor-pointer">
            <input
              type="file"
              class="cust-fil-input w-full"
              id="customFileLang1"
              lang="en"
              ref="coverPhoto"
              @change="onFileChange"
            />
            <div v-if="coverPic == ''">
              <label class="custom-file-label" for="customFileLang1"
                >Upload Cover Image</label
              >
            </div>
            <div v-else>
              <label class="custom-file-label" for="customFileLang1">{{
                coverPic
              }}</label>
            </div>
          </div>
        </div>

        <div class="form-group md:col-6 lg:col-6 col-12">
          <label for="customFileLang" class="form-control-label"
            >Profile Photo</label
          >
          <div class="custom-file cursor-pointer">
            <input
              type="file"
              class="cust-fil-input w-full"
              id="customFileLang"
              lang="en"
              ref="profilePhoto"
              @change="onFileChange"
            />
            <div v-if="profilePic == ''">
              <label class="custom-file-label" for="customFileLang"
                >Upload Profile Image</label
              >
            </div>
            <div v-else>
              <label class="custom-file-label" for="customFileLang">{{
                profilePic
              }}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label class="font-medium fsize-rm" for="exampleFormControlTextarea1"
          >About Me</label
        >
        <div class="">
          <quill-editor
            :options="editorOption"
            class="quill-h300px"
            v-model="userDetails.aboutMe"
          />
        </div>
      </div>

      <div class="row">
        <div class="form-group md:col-6 lg:col-6 col-12">
          <label for="example-text-input" class="form-control-label"
            >Designation</label
          >
          <b-input
            type="text"
            class="form-control"
            placeholder="Enter Your Designation"
            v-model="userDetails.designation"
          />
        </div>

        <div class="form-group md:col-6 lg:col-6 col-12">
          <label for="example-text-input" class="form-control-label"
            >Location</label
          >
          <b-form-select
            v-model="userDetails.location"
            :options="location"
          ></b-form-select>
        </div>
      </div>

      <div class="row">
        <div class="form-group md:col-6 lg:col-6 col-12">
          <label for="example-text-input" class="form-control-label"
            >Phone</label
          >
          <b-input
            type="number"
            class="form-control"
            placeholder="Enter Phone No"
            v-model="userData.mobile"
            disabled
          />
        </div>

        <div class="form-group md:col-6 lg:col-6 col-12">
          <label for="example-text-input" class="form-control-label"
            >Email</label
          >
          <b-input
            type="email"
            class="form-control"
            placeholder="Enter Email ID"
            v-model="userData.email"
            disabled
          />
        </div>
      </div>

      <div class="row">
        <div class="form-group md:col-6 lg:col-6 col-12">
          <label for="example-text-input" class="form-control-label"
            >Linkedin Link</label
          >
          <b-input
            type="text"
            class="form-control"
            placeholder="Enter Linkedin Link "
            v-model="userDetails.linkedin"
          />
        </div>

        <div class="form-group md:col-6 lg:col-6 col-12">
          <label for="example-text-input" class="form-control-label"
            >Youtube Link</label
          >
          <b-input
            type="tetx"
            class="form-control"
            placeholder="Enter Youtube Link"
            v-model="userDetails.youtube"
          />
        </div>
      </div>

      <div class="row">
        <div class="form-group md:col-6 lg:col-6 col-12">
          <label for="example-text-input" class="form-control-label"
            >Twitter Link</label
          >
          <b-input
            type="text"
            class="form-control"
            placeholder="Enter Twitter Link "
            v-model="userDetails.twitter"
          />
        </div>

        <div class="form-group md:col-6 lg:col-6 col-12">
          <label for="example-text-input" class="form-control-label"
            >Facebook Link</label
          >
          <b-input
            type="text"
            class="form-control"
            placeholder="Enter Facebook Link"
            v-model="userDetails.facebook"
          />
        </div>
      </div>

      <div class="flex mt-4">
        <button type="button" class="btn btn-success" @click="updateAuthor()">
          Save Changes
        </button>
        <button type="button" class="btn btn-secondary">Cancel</button>
      </div>
    </form>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import TextEditor from "./TextEditor";
export default {
  props: {
    userDetails: Object,
  },
  data() {
    return {
      editorOption: {
        modules: {
          toolbar: [
            [
              "bold",
              "italic",
              "underline",
              "strike",
              "link",
              "blockquote",
              "code-block",
            ],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ font: [] }],
          ],
        },
        placeholder: "Message",
      },
      selected: null,
      location: [
        { value: null, text: "Please select an option" },
        { value: "Mumbai", text: "Mumbai" },
        { value: "Gujrat", text: "Gujrat" },

        { value: "Akola", text: "Akola" },
      ],

      coverPic: "",
      profilePic: "",
    };
  },
  components: {
    TextEditor,
    quillEditor,
  },
  methods: {
    onFileChange(e) {
      if (this.$refs.coverPhoto.files[0]) {
        this.coverPic = this.$refs.coverPhoto.files[0].name;
        // console.log(this.coverPic);
      }
      if (this.$refs.profilePhoto.files[0]) {
        this.profilePic = this.$refs.profilePhoto.files[0].name;
      }
    },
    async updateAuthor() {
      const payload = new FormData();
      payload.append("_id", this.userDetails._id);
      if (this.coverPic == "") {
        payload.append("coverPhoto", "");
      } else {
        payload.append("coverPhoto", this.$refs.coverPhoto.files[0]);
      }
      if (this.profilePic == "") {
        payload.append("profilePhoto", "");
      } else {
        payload.append("profilePhoto", this.$refs.profilePhoto.files[0]);
      }
      payload.append("location", this.userDetails.location);
      payload.append("designation", this.userDetails.designation);
      payload.append("linkedin", this.userDetails.linkedin);
      payload.append("youtube", this.userDetails.youtube);
      payload.append("twitter", this.userDetails.twitter);
      payload.append("facebook", this.userDetails.facebook);
      payload.append("aboutMe", this.userDetails.aboutMe);
      // let formObj = {};
      // for (var pair of payload.entries()) {
      //   formObj[pair[0]] = pair[1];
      // }
      // console.log(formObj);
      if (this.userData.role == "author") {
        const { data } = await this.$store.dispatch(
          "author/editAuthors",
          payload
        );
        this.$swal.fire({
          title: "Updated",

          text: "Profile has been updated successfully!",

          icon: "success",
          showConfirmButton: false,
          showCancelButton: false,
          timer: 2000,
        });
        // console.log(data);
      } else {
        const { data } = await this.$store.dispatch(
          "student/editStudents",
          payload
        );
        this.$swal.fire({
          title: "Updated",

          text: "Profile has been updated successfully!",

          icon: "success",
          showConfirmButton: false,
          showCancelButton: false,
          timer: 2000,
        });
        // console.log(data);
        // console.log("student");
      }
    },
  },
  computed: {
    ...mapState("auth", ["userData"]),
  },
};
</script>
